<div>
    <!-- Loading State -->
    <div *ngIf="isLoadingDocument" class="loading-container" [style.height]="height">
        <div class="loading-content">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="loading-text">Loading document...</p>
        </div>
    </div>

    <!-- Editor (hidden while loading) -->
    <div [style.display]="isLoadingDocument ? 'none' : 'block'">
        <div class="editor-header" *ngIf="showHeader">
            <div class="header-left">
                <h3>{{documentName}}</h3>
            </div>
            <div class="header-actions">
                <button *ngIf="showPublishButton"
                        class="table-action-button-orange"
                        (click)="publishClicked.emit()"
                        [disabled]="!publishButtonEnabled">
                    Publish Policy
                </button>
                <button *ngIf="showSaveButton"
                        class="table-action-button-orange-solid"
                        (click)="saveDocument()"
                        [disabled]="saveStatus === 'saving' || !hasContentChanged">
                    Save
                </button>
                <button *ngIf="showCloseButton"
                        mat-icon-button
                        (click)="onCloseEditor()"
                        [matTooltip]="'Close editor'">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div class="editor-wrapper">
            <ejs-documenteditorcontainer
                #documenteditor_default
                [enableToolbar]="enableToolbar"
                [toolbarMode]="'Ribbon'"
                [ribbonLayout]="'Classic'"
                [height]="height"
                (mousedown)="$event.stopPropagation()"
                (created)="onCreate()"
                (documentChange)="onDocumentChange($event)"
                (contentChange)="onContentChange()">
            </ejs-documenteditorcontainer>
            <div *ngIf="autoSaveIndicator !== 'idle'" class="autosave-indicator" [class.saving]="autoSaveIndicator === 'saving'" [class.saved]="autoSaveIndicator === 'saved'">
                <mat-icon>{{ autoSaveIndicator === 'saving' ? 'save' : 'check_circle' }}</mat-icon>
                <span>{{ autoSaveIndicator === 'saving' ? 'Saving...' : 'Auto save' }}</span>
            </div>
        </div>

    </div>
</div>